import React, { useEffect, useMemo } from 'react';
import { usePortfolioProfileRoles } from 'queries/roles';
import SimpleTable from 'modules/Tables/SimpleTable';
import LoadingBar from '@hubins/components/LoadingIndicators';
import __ from 'localisation';
import BackofficeProfileLink from '../BackofficeProfileLink';

const loadingObject = {
  name: <LoadingBar />,
  national_identity_number: <LoadingBar />,
  role: [],
  position: <LoadingBar />,
  ownership_percentage: <LoadingBar />,
};

const loadingState = [
  loadingObject,
  loadingObject,
  loadingObject,
  loadingObject,
  loadingObject,
  loadingObject,
  loadingObject,
];

const headers = [
  {
    Header: __('name'),
    accessor: 'name',
  },
  {
    Header: __('national_identity_number'),
    accessor: 'national_identity_number',
  },
  {
    Header: __('role'),
    accessor: 'role',
    Cell: ({ row }) => {
      const roles = row?.original?.role;
      if (!roles) return null;
      return roles.map((role, index) => {
        return <div key={role}>{__(role)}{index < roles.length - 1 ? ', ' : ''}</div>;
      });
    },
  },
  {
    Header: __('type'),
    accessor: 'position',
  },
  {
    Header: __('ownership_percentage'),
    accessor: 'ownership_percentage',
  },
];
const PortfolioProfileRolesTable = ({ profileUuid, portfolioUuid }) => {
  const { data, isLoading, isFetched, isError } = usePortfolioProfileRoles(portfolioUuid, profileUuid);

  return (
    <SimpleTable headers={headers} data={(isLoading || !isFetched || isError ) ? loadingState : data} />
  );
};

export default PortfolioProfileRolesTable;